
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shopping/deals",
      function () {
        return require("private-next-pages/shopping/deals.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/shopping/deals"])
      });
    }
  